import React, { useMemo, ReactElement } from 'react';
import FilterContainer from '../../../components/filter-container/filter-container.component';
import FilterSelectField from '../../../components/filter-select-field/filter-select-field.component';
import MenuItemList from '../../../components/menu-item-list/menu-item-list.component';
import { FILTER_VALUE_EMPTY } from '../../../constants/system/filter-values';
import { CONTACT_TYPE_PERSON } from '../../../constants/entity/contact-types';
import {
  FILTER_TYPE_CONTACT_TYPE, FILTER_TYPE_COMPANY_ID, FILTER_TYPE_LOCATION, FILTER_TYPE_ASSET_TYPE, FILTER_TYPE_TAG_ID,
} from '../../../constants/system/filter-types';

const ContactListFilters: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    currentFilters,
    filters,
    filterContactTypeList,
    filterContactCompanyList,
    filterLocationList,
    filterAssetTypeList,
    filterTagList,
    onSetFilterValue,
  } = props;

  const filterContactType: string = filters && filters[FILTER_TYPE_CONTACT_TYPE];
  const filterContactCompanyId: number = filters && filters[FILTER_TYPE_COMPANY_ID];
  const filterLocation: string = filters && filters[FILTER_TYPE_LOCATION];
  const filterAssetType: string = filters && filters[FILTER_TYPE_ASSET_TYPE];
  const filterTagId: string = filters && filters[FILTER_TYPE_TAG_ID];

  const menuItemFilterContactTypeList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: filterContactTypeList,
    selectedValue: filterContactType,
  }), [filterContactTypeList, filterContactType]);

  const menuItemFilterContactCompanyList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemLabelKey: 'name',
    optionList: filterContactCompanyList,
    selectedValue: filterContactCompanyId,
  }), [filterContactCompanyList, filterContactCompanyId]);

  const menuItemFilterLocationList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionItemLabelKey: 'name',
    optionList: filterLocationList,
    selectedValue: filterLocation,
  }), [filterLocationList, filterLocation]);

  const menuItemFilterAssetTypeList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemValueKey: 'name',
    optionList: filterAssetTypeList,
    selectedValue: filterAssetType,
  }), [filterAssetTypeList, filterAssetType]);

  const menuItemFilterTagList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    optionItemLabelKey: 'name',
    optionList: filterTagList,
    selectedValue: filterTagId,
  }), [filterTagList, filterTagId]);

  return (
    <FilterContainer>
      <FilterSelectField
        filterType={FILTER_TYPE_CONTACT_TYPE}
        label="Contact Type"
        value={currentFilters[FILTER_TYPE_CONTACT_TYPE] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterContactTypeList}
        onSetFilterValue={onSetFilterValue}
      />
      {
        currentFilters[FILTER_TYPE_CONTACT_TYPE] === CONTACT_TYPE_PERSON && (
          <FilterSelectField
            isInteger
            filterType={FILTER_TYPE_COMPANY_ID}
            label="Company"
            value={currentFilters[FILTER_TYPE_COMPANY_ID] || FILTER_VALUE_EMPTY}
            currentFilters={currentFilters}
            menuItemList={menuItemFilterContactCompanyList}
            onSetFilterValue={onSetFilterValue}
          />
        )
      }
      <FilterSelectField
        filterType={FILTER_TYPE_LOCATION}
        label="Location"
        value={currentFilters[FILTER_TYPE_LOCATION] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterLocationList}
        onSetFilterValue={onSetFilterValue}
      />
      <FilterSelectField
        filterType={FILTER_TYPE_ASSET_TYPE}
        label="Asset Class"
        value={currentFilters[FILTER_TYPE_ASSET_TYPE] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterAssetTypeList}
        onSetFilterValue={onSetFilterValue}
      />
      <FilterSelectField
        isInteger
        filterType={FILTER_TYPE_TAG_ID}
        label="Tag"
        value={currentFilters[FILTER_TYPE_TAG_ID] || FILTER_VALUE_EMPTY}
        currentFilters={currentFilters}
        menuItemList={menuItemFilterTagList}
        onSetFilterValue={onSetFilterValue}
      />
    </FilterContainer>
  );
});

export default ContactListFilters;
